'use strict'

const flow_ = require('lodash/flow')
const mapValues_ = require('lodash/mapValues')
const { sanitizePII } = require('bi-logger-sanitizer')

const undefinedFilterMutator = (next = x => x) => params => {
  const filteredParams = Object.assign({}, params)
  Object.keys(filteredParams).forEach(
    key => filteredParams[key] === undefined && delete filteredParams[key]
  )

  return next(filteredParams)
}

const objectFilterMutator = (next = x => x) => params => {
  const filteredParams = {}
  Object.keys(params).forEach(
    key =>
      (filteredParams[key] =
        typeof params[key] === 'object'
          ? JSON.stringify(params[key])
          : params[key])
  )

  return next(filteredParams)
}

const timestampDeltaMutator = (editorTimestamp, next = x => x) => params => {
  return next(
    Object.assign({}, params, { ts: new Date().getTime() - editorTimestamp })
  )
}

const sanitizeEvent = event => mapValues_(event, sanitizePII)

const loggerFactory = (biFactory, mutator = x => x) => {
  const logger = biFactory.logger()
  return flow_(mutator, sanitizeEvent, logger.log.bind(logger))
}

module.exports.BI_ENDPOINT = 'platform'
module.exports.BI_VIEWER_ENDPOINT = 'platform-viewer'
module.exports.BI_ERROR_ENDPOINT = 'trg'
module.exports.BI_SOURCE = 79
module.exports.biExceptionLogger = (...args) => {
  throw new Error(
    `Attempt to call BI logger too soon. Arguments: ${JSON.stringify(args)}`
  )
}
module.exports.undefinedFilterMutator = undefinedFilterMutator
module.exports.objectFilterMutator = objectFilterMutator
module.exports.timestampDeltaMutator = timestampDeltaMutator
module.exports.loggerFactory = loggerFactory



// WEBPACK FOOTER //
// ../node_modules/dbsm-common/src/bi/bi.js